import React, { useEffect, useState } from 'react';
import styles from './DebtProducts.module.scss';
import useLegacyBusinessDataFetch from '../DataRoom/useLegacyBusinessDataFetch';
import { Button } from '../../common/_custom';
import {
    caretRight,
    CrossIconPurple,
    ctaGrey,
    debtProdFilters,
    debtProductsEmpty,
    editProfileIcon,
    NOT_ALLOWED,
    pendingDataComplete,
    PendingDataIncomplete,
    plusWhite,
    PURPLE_CROSS,
} from '../../assets/hostedassets';
import LoadingSpinner from '../../common/_custom/LoadingSpinner/LoadingSpinner';
import ManageDealDrawer from '../../common/ManageDealDrawer/ManageDealDrawer';
import { setDealDrawer } from '../../store/investor/action';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import clsx from 'clsx';
import ProbabilityBar from './components/ProbabilityBar/ProbabilityBar';
import probabilityBarStyles from './components/ProbabilityBar/ProbabilityBar.module.scss';
import DebtProductOverview from './components/DebtProductOverview/DebtProductOverview';
import Tooltip from '../../common/_custom/Tooltip/Tooltip';
import { DebtProductRowData } from './debtProductTypes';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useDebtProductLogic from './useDebtProductLogic';
import { USER_TYPE } from '../../utils/constants/user';
import { getDataGapDocs } from '../../common/MagicUpload/MagicUploadHelper';
import { isEmpty } from '../../utils/utils';
import AIText from '../../common/AIText/AIText';
import { setDebtProductsFilters } from '../../store/company/action';
import DealSuccessModal from '../../common/DealApplicationDrawer/Components/DealSuccessModal/DealSuccessModal';
import DeleteModal from '../../common/ConfigurableModal/ConfigurableModal';
import { useManageDealDrawer } from '../../common/ManageDealDrawer/useManageDealDrawer';
import AskAicaV2 from '../Dashboard/DashboardModules/Overview/components/AskAicaV2/AskAicaV2';
import { useVisibilityConfig } from '../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';
import MandateDropdown from './components/MandateDropdown/MandateDropdown';
import { MANDATE_STATES } from '../../utils/constants/commonConstants';

function DebtProducts() {
    const dispatch = useAppDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { exportData, isUserRestricted, selectedCompany, refreshReportStatus, downloadPDFStatus, goBackToPortfolio } =
        useLegacyBusinessDataFetch();
    const header = document.getElementById('header') ?? document.createElement('div');
    const {
        loading, //component loading state
        noPecExists, //true if there are no existing PECs
        companyMetricsDataExists,
        showDetailOverview, //used to store row data for opening modal
        debtProductsData, //data used to render table
        showEmptyScreen, //boolean to show empty screen
        dealDrawerState,
        setDebtProductsData,
        setShowDetailOverview,
        fetchPECDataAndDebtProductsData,
        fetchCompanyMetrics,
        updateDealDataState,
        dealPayload,
        selectionCount,
        clearSelection,
        saveSelection,
        dealId,
        savingDraft,
        draftSelectionCount,
        fetchDebtProductsData,
        //MIXPANEL
        registerMixpanelForRowExpand,
        registerMixpanelForUserHelpClick,
        registerMixpanelForEditProfileClicked,
        showFilters,
        renderDealActionButton,
        renderClearOrDeleteButton,
        renderMessage,
        showDeleteModal,
        setShowDeleteModal,
        dealStatus,
        originalDealPayloadRef,
        draftDealsData,
        dealStatusConfig,
        selectedMandate,
        handleMandateSelection,
        isCheckboxDisabled,
        mandateState,
        percentageCompletion,
        //Probability tooltip
        getProbabilityTooltip,
        PROBABILITY_TOOLTIP_MESSAGES,
    } = useDebtProductLogic({ params, selectedCompany });

    const { isVisible } = useVisibilityConfig();

    const user = useAppSelector((state) => state.user);
    const investorData = useAppSelector((state) => state.investor);
    const commentsThreadState = useAppSelector((state) => state.commentsThreadReducer);
    const debtFilters = useAppSelector((state) => state.company.debtProductsFilters);
    const permissions = investorData.permissions;
    const showDataGapCTA = permissions.showDataGap;
    const isDemoProfile = !!selectedCompany?.demoOrg;
    const [searchParams, setSearchParams] = useSearchParams();
    const isCompanySide = user.userData.accountType === USER_TYPE.COMPANY || location.pathname.includes('company');
    const showSuccessModal = useAppSelector((state) => state.investor.dealApplicationDrawer.showSuccessModal);
    const assesseeOrgId = params.id;

    // const getPendingDocumentsCount = async () => {
    //     await getDataGapDocs(
    //         {
    //             assesseeOrgId: params.id ?? '',
    //         },
    //         {
    //             onSuccess: (res) => {
    //                 dispatch(updateNeedInfoFileNumber(res.pendingCount));
    //             },
    //         },
    //     );
    // };

    const openNeedInfoDrawer = () => {
        searchParams.set('borrowerReq', 'true');
        setSearchParams(searchParams);
    };

    // useEffect(() => {
    //     getPendingDocumentsCount();
    // }, []);
    // const openCreatePECDrawer = () => {
    //     dispatch(
    //         setDealDrawer({
    //             open: true,
    //             drawerLabel: 'Create New Eligibility',
    //             isPec: true,
    //         }),
    //     );
    // };

    const countSelectedLenderCount = (rowData) => {
        let count = 0;
        rowData?.lenders?.forEach((lender) => {
            if (dealPayload.lenders.has(lender.lenderId) && dealPayload.lenders.get(lender.lenderId)?.includes(rowData.productId)) {
                count += 1;
            }
        });
        return count;
    };

    const renderHeaderButton = () => {
        if (user.userData.accountType === USER_TYPE.INVESTOR && !isDemoProfile && showDataGapCTA) {
            return (
                <>
                    <div
                        className={clsx({
                            // [styles.PedingCTA]: (pendingCount as number) > 0 || pendingCount === null,
                            // [styles.PendingDone]: pendingCount === 0,
                            [styles.PedingCTA]: true,
                        })}
                        onClick={() => openNeedInfoDrawer()}
                    >
                        <img src={PendingDataIncomplete} alt="pendingDataComplete" />
                        <span>Data Pending</span>
                    </div>
                </>
            );
        }
        return <></>;
    };

    const renderEmptyScreen = () => {
        return (
            <div className={styles.Empty}>
                <img src={debtProductsEmpty} alt={''} height={'100px'} />
                {noPecExists ? (
                    <div className={styles.Text}>
                        {/*<span className={styles.Link} onClick={openCreatePECDrawer}>*/}
                        {/*    Add PEC*/}
                        {/*</span>*/}
                        &nbsp;Please set investment preferences first
                    </div>
                ) : companyMetricsDataExists ? (
                    <></>
                ) : (
                    isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.EDIT_PROFILE) && (
                        <div className={styles.Text}>
                            <span
                                className={styles.Link}
                                onClick={() => {
                                    dispatch(
                                        setDealDrawer({
                                            open: true,
                                            drawerLabel: 'Edit Profile',
                                            companyName: selectedCompany?.orgName,
                                        }),
                                    );
                                    registerMixpanelForEditProfileClicked('Empty Screen');
                                }}
                            >
                                Edit Profile
                            </span>
                            &nbsp;to view products with probability
                        </div>
                    )
                )}
            </div>
        );
    };

    const checkIfChecked = (rowData, isParentRow: boolean) => {
        if (mandateState === MANDATE_STATES.SHARED && !isParentRow) {
            return (
                originalDealPayloadRef.current.lenders.has(rowData.lenderId) ||
                (dealPayload.lenders.has(rowData.lenderId) && dealPayload.lenders.get(rowData.lenderId)?.includes(rowData.productId))
            );
        }
        if (dealPayload.products?.includes(rowData.productId) && isParentRow) {
            return true;
        } else if (
            dealPayload.lenders.has(rowData.lenderId) &&
            dealPayload.lenders.get(rowData.lenderId)?.includes(rowData.productId) &&
            !isParentRow
        ) {
            return true;
        }
        return false;
    };

    const showLoader = () => (
        <div className={styles.Loader}>
            <LoadingSpinner color="#6021B3" height={'40px'} />
            <div className={styles.Text}>{`Fetching ${debtProductsData.visibilityStates.debtProductName}`}</div>
        </div>
    );

    const getSecurityTooltip = (securities: string[] = []) => {
        return (
            <div className={styles.SecuritiesTooltip}>
                {securities?.map((sec, i) => (
                    <div className={styles.SingleSecurity} key={sec}>
                        &bull;&nbsp;&nbsp;{sec}
                    </div>
                ))}
            </div>
        );
    };

    const renderRowItem = (headerId, rowData: DebtProductRowData, isParentRow = false) => {
        if (headerId === 'caret' && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
            return null;
        }

        if (headerId === 'select') {
            if (
                (isParentRow && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT)) ||
                (!isParentRow && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_LENDER))
            ) {
                return null;
            }
        }

        let renderComponent = <></>;
        switch (headerId) {
            case 'productName':
                renderComponent = (
                    <div
                        className={clsx(styles.Product, {
                            [styles.ProductSub]: !isParentRow,
                        })}
                    >
                        {(isParentRow ? rowData?.[headerId] : rowData?.['lenderName']) || '-'}
                        {!isParentRow && rowData?.isNegativeLender && (
                            <img src={NOT_ALLOWED} alt="na" height={'16px'} className={styles.NotAllowedIcon} />
                        )}
                        {isParentRow && !!rowData?.lenders?.length && (
                            <div className={styles.Count}>
                                {countSelectedLenderCount(rowData)}/{rowData?.lenders?.length}
                            </div>
                        )}
                    </div>
                );
                break;
            case 'select':
                if (
                    (isParentRow && isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT)) ||
                    (!isParentRow && isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_LENDER))
                ) {
                    renderComponent = (
                        <input
                            type="checkbox"
                            className={styles.Checkbox}
                            checked={checkIfChecked(rowData, isParentRow)}
                            disabled={isCheckboxDisabled(rowData, isParentRow)}
                            onChange={(e) => {
                                e.stopPropagation();
                                if (isParentRow) {
                                    updateDealDataState(rowData.productId, 'product');
                                } else {
                                    updateDealDataState(
                                        {
                                            productId: rowData.productId,
                                            lenderId: rowData.lenderId,
                                        },
                                        'investor',
                                    );
                                }
                            }}
                        />
                    );
                } else {
                    renderComponent = <></>;
                }
                break;
            case 'caret':
                if (isParentRow && isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
                    renderComponent = (
                        <div
                            className={clsx(styles.CaretDiv, {
                                [styles.CaretDivHov]: rowData.expand,
                            })}
                        >
                            <img
                                className={clsx(styles.CaretImg, {
                                    [styles.ExpandedCaret]: rowData?.expand && isParentRow,
                                    [styles.DisabledCaret]: !rowData?.lenders?.length,
                                })}
                                src={caretRight}
                                height={'14px'}
                                alt={''}
                                style={{ marginTop: '4px' }}
                            />
                        </div>
                    );
                }
                break;
            case 'probability': {
                const probabilityRow = (
                    <div className={styles.ProbabilityRow} style={{ opacity: 1 }}>
                        <ProbabilityBar probability={rowData?.[headerId]} pecThreshold={rowData?.pecValues?.PEC_THRESHOLD_PERCENTAGE} />
                        <img src={ctaGrey} alt={''} height={'12px'} />
                    </div>
                );
                const tooltipData = getProbabilityTooltip(rowData?.[headerId], rowData?.pecValues?.PEC_THRESHOLD_PERCENTAGE);

                renderComponent = tooltipData ? (
                    <Tooltip
                        content={
                            <div className={probabilityBarStyles.TooltipContent}>
                                <span className={probabilityBarStyles.TooltipText}>{tooltipData.message}</span>
                                {tooltipData.recommendedPercentage && (
                                    <span className={probabilityBarStyles.TooltipRecommended}>
                                        Recommended: {tooltipData.recommendedPercentage}
                                    </span>
                                )}
                            </div>
                        }
                        direction="top"
                        usePortal={true}
                        style={{ width: '200px', maxWidth: '250px' }}
                        containerFullWidth={false}
                    >
                        {probabilityRow}
                    </Tooltip>
                ) : (
                    probabilityRow
                );
                break;
            }
            case 'security': {
                const totalElements = rowData?.security?.length;
                renderComponent = totalElements ? (
                    <Tooltip content={getSecurityTooltip(rowData?.security)} direction={'top'} fitContent>
                        <div className={styles.SecurityContainer}>
                            {rowData?.security?.slice(0, 1)?.map((sec, i) =>
                                !!sec ? (
                                    <div key={i} className={styles.SecurityItem}>
                                        {sec}
                                    </div>
                                ) : (
                                    '-'
                                ),
                            )}
                            {totalElements > 1 && <div className={styles.More}>+{totalElements - 1} more</div>}
                        </div>
                    </Tooltip>
                ) : (
                    <>-</>
                );
                break;
            }

            default:
                renderComponent = rowData?.[headerId] ?? '-';
        }

        return (
            <td
                key={header.id}
                className={clsx({
                    [styles.RowItem]: true,
                    [styles.SelectColInner]: headerId === 'select' && !isParentRow,
                    [styles.SelectCol]: headerId === 'select' && isParentRow,
                    [styles.CaretCol]: headerId === 'caret' && isParentRow,
                    [styles.CaretColInner]: headerId === 'caret' && !isParentRow,
                    [styles.ProductsCol]: headerId === 'productName',
                    [styles.ProbabilityCol]: headerId === 'probability',
                    [styles.SecurityCol]: headerId === 'security',
                    [styles.DisabledRowItem]: isParentRow && !rowData?.lenders?.length,
                    [styles.NoSelectMode]:
                        headerId === 'select' &&
                        ((isParentRow && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT)) ||
                            (!isParentRow && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_LENDER))),
                })}
                onClick={(e) => {
                    switch (headerId) {
                        case 'caret':
                            e.stopPropagation();
                            if (isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
                                expandOrCollapseRow(rowData, isParentRow);
                            }
                            break;
                        case 'probability':
                            e.stopPropagation();
                            setShowDetailOverview(rowData);
                            registerMixpanelForUserHelpClick(rowData, isParentRow);
                            break;
                        case 'select':
                            e.stopPropagation();
                            break;
                        default:
                            break;
                    }
                }}
            >
                {renderComponent}
            </td>
        );
    };

    const expandOrCollapseRow = (rowData, isParentRow) => {
        if (isParentRow && rowData?.lenders?.length && isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
            if (!rowData.expand) {
                registerMixpanelForRowExpand(rowData);
            }
            setDebtProductsData((existing: any) => ({
                ...existing,
                rows: existing.rows.map((row) => ({
                    ...row,
                    ...(row.productId === rowData.productId && {
                        expand: !row.expand,
                    }),
                })),
            }));
        }
    };

    return (
        <>
            <div
                className={clsx({
                    [styles.DebtProducts]: true,
                    [styles.DebtProductsCompany]: isCompanySide,
                    [styles.NoAccordion]: !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION),
                    [styles.NoSelectProduct]: !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT),
                    [styles.NoSelectLender]: !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_LENDER),
                })}
            >
                <div className={styles.Container}>
                    <div className={styles.Top}>
                        <div className={styles.TitleSection}>
                            <div className={styles.Title}>{debtProductsData.visibilityStates.debtProductName ?? 'Debt Products'}</div>
                            <MandateDropdown
                                data={draftDealsData}
                                dealStatusConfig={dealStatusConfig}
                                selectedMandate={selectedMandate}
                                placeholder="Select Mandate"
                                onSelect={(mandate) => {
                                    handleMandateSelection(mandate);
                                }}
                                onClear={() => handleMandateSelection(null)}
                                className={styles.MandateDropdown}
                                disabled={isEmpty(draftDealsData)}
                            />
                        </div>
                        <div className={styles.Right}>
                            {showFilters && (
                                <Button
                                    text={isEmpty(debtFilters) ? 'Add Filters' : 'Filters Applied'}
                                    onClick={() => {
                                        dispatch(
                                            setDealDrawer({
                                                open: true,
                                                drawerLabel: 'Filters',
                                                drawerSource: 'Debt Products Filters',
                                            }),
                                        );
                                    }}
                                    icon={debtProdFilters}
                                    style={
                                        isEmpty(debtFilters)
                                            ? { marginTop: '0' }
                                            : {
                                                  marginTop: 0,
                                                  background: '#F2E8FF',
                                                  border: '1px solid transparent',
                                              }
                                    }
                                    variant={'purpleinverted'}
                                    endIcon={isEmpty(debtFilters) ? null : PURPLE_CROSS}
                                    endIconClick={() => {
                                        dispatch(setDebtProductsFilters({}));
                                        fetchDebtProductsData({});
                                    }}
                                />
                            )}
                            {isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.EDIT_PROFILE) && (
                                <Button
                                    text={
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.75rem',
                                                width: '100%',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <span>Edit Profile</span>
                                            {percentageCompletion?.borrowerFinancials?.actualData !== undefined && (
                                                <div className={styles.PercentageCompletion}>
                                                    {percentageCompletion?.borrowerFinancials?.actualData}%
                                                </div>
                                            )}
                                        </div>
                                    }
                                    onClick={() => {
                                        dispatch(
                                            setDealDrawer({
                                                open: true,
                                                drawerLabel: 'Edit Profile',
                                                companyName: selectedCompany?.orgName,
                                            }),
                                        );
                                        registerMixpanelForEditProfileClicked('Kebab Menu');
                                    }}
                                    variant="purple"
                                    style={{ marginTop: '0' }}
                                    icon={editProfileIcon}
                                />
                            )}
                        </div>
                    </div>

                    <div className={styles.Body}>
                        <div
                            // style={selectionCount > 0 || draftSelectionCount > 0 ? { height: 'calc(100vh - 280px)' } : {}}
                            className={styles.TableContainer}
                        >
                            <table className={styles.Table}>
                                <thead>
                                    <tr className={styles.HeadersRow}>
                                        {debtProductsData?.headers?.length ? (
                                            debtProductsData?.headers
                                                .filter((header) => {
                                                    if (header.id === 'caret' && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
                                                        return false;
                                                    }
                                                    if (header.id === 'select' && !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT)) {
                                                        return false;
                                                    }
                                                    return true;
                                                })
                                                .map((header) => (
                                                    <th
                                                        key={header?.id}
                                                        className={clsx({
                                                            [styles.Header]: true,
                                                            [styles.SelectCol]: header.id === 'select',
                                                            [styles.CaretCol]: header.id === 'caret',
                                                            [styles.ProductsCol]: header.id === 'productName',
                                                            [styles.ProbabilityCol]: header.id === 'probability',
                                                            [styles.SecurityCol]: header.id === 'security',
                                                            [styles.NoAccordionMode]: !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION),
                                                        })}
                                                    >
                                                        {header.label}
                                                    </th>
                                                ))
                                        ) : (
                                            <th className={clsx(styles.Header, styles.EmptyHeader)}>{'-'}</th>
                                        )}
                                    </tr>
                                </thead>
                                {!loading && !showEmptyScreen && (
                                    <tbody className={styles.TableBody}>
                                        {debtProductsData?.rows?.map((rowData: DebtProductRowData, i) => (
                                            <React.Fragment key={i}>
                                                <tr
                                                    key={`${i}-${rowData?.productId}`}
                                                    className={clsx(styles.TableRow, styles.ParentRow, {
                                                        [styles.ExpandedRow]: rowData?.expand,
                                                        [styles.NoAccordionMode]: !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION),
                                                    })}
                                                    onClick={() => {
                                                        if (isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)) {
                                                            expandOrCollapseRow(rowData, true);
                                                            registerMixpanelForUserHelpClick(rowData, true);
                                                        }
                                                    }}
                                                >
                                                    {debtProductsData?.headers
                                                        .filter((header) => {
                                                            if (
                                                                header.id === 'caret' &&
                                                                !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)
                                                            ) {
                                                                return false;
                                                            }
                                                            if (
                                                                header.id === 'select' &&
                                                                !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_PRODUCT)
                                                            ) {
                                                                return false;
                                                            }

                                                            return true;
                                                        })
                                                        .map((header) => (
                                                            <React.Fragment key={header.id}>
                                                                {renderRowItem(header.id, rowData, true)}
                                                            </React.Fragment>
                                                        ))}
                                                </tr>
                                                {rowData?.expand &&
                                                    rowData?.lenders?.map((lenderData: DebtProductRowData, j) => (
                                                        <tr
                                                            key={j}
                                                            className={clsx(styles.TableRow, styles.Subrow, {
                                                                [styles.NoAccordionMode]: !isVisible(
                                                                    VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION,
                                                                ),
                                                            })}
                                                            onClick={() => {
                                                                setShowDetailOverview(lenderData);
                                                                registerMixpanelForUserHelpClick(rowData, false);
                                                            }}
                                                        >
                                                            {debtProductsData?.headers
                                                                .filter((header) => {
                                                                    if (
                                                                        header.id === 'caret' &&
                                                                        !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.ACCORDION)
                                                                    ) {
                                                                        return false;
                                                                    }
                                                                    if (
                                                                        header.id === 'select' &&
                                                                        !isVisible(VISIBILITY_KEYS.DEBT_PRODUCT.SELECT_LENDER)
                                                                    ) {
                                                                        return false;
                                                                    }

                                                                    return true;
                                                                })
                                                                .map((header) => (
                                                                    <React.Fragment key={header.id}>
                                                                        {renderRowItem(header.id, lenderData, false)}
                                                                    </React.Fragment>
                                                                ))}
                                                        </tr>
                                                    ))}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                            {loading && showLoader()}
                            {!loading && showEmptyScreen && renderEmptyScreen()}
                        </div>
                    </div>
                </div>

                {searchParams.get('createMandate') && (
                    <DealSuccessModal
                        showSuccessModal={showSuccessModal}
                        heading="Mandate Created Successfully"
                        subHeading="You can share deal with lenders now."
                        buttonText="View Mandate"
                        buttonOnClick={() =>
                            navigate(
                                `/investor/app/company-deals/${assesseeOrgId}?page=1&fetchType=all&type=deals&category=MANDATE_VIEW&tab=deals`,
                                {
                                    state: {
                                        ...{ from: 'SCAN' },
                                    },
                                },
                            )
                        }
                        queryParamsToClearOnClose={['createMandate']}
                        showCrossButton={true}
                        onCLose={() => {
                            originalDealPayloadRef.current = dealPayload;
                        }}
                    />
                )}
                {searchParams.get('deleteMandate') && (
                    <DeleteModal
                        isOpen={showDeleteModal}
                        onClose={() => {
                            setShowDeleteModal(false);
                            searchParams.delete('deleteMandate');
                            setSearchParams(searchParams);
                        }}
                        deleteFunction={() => {
                            saveSelection('DRAFT_DELETED', dealId);
                            setShowDeleteModal(false);
                            searchParams.delete('deleteMandate');
                            setSearchParams(searchParams);
                        }}
                        heading={'Delete Mandate'}
                        message={'Are you sure you want to delete this mandate?'}
                    />
                )}
                {dealDrawerState.open && (
                    <ManageDealDrawer
                        source={dealDrawerState?.drawerSource ?? 'Debt Products'}
                        onClose={(payload) => {
                            fetchPECDataAndDebtProductsData(payload);
                            const isEditProfile = dealDrawerState?.drawerLabel === 'Edit Profile';
                            fetchCompanyMetrics(false, isEditProfile);
                        }}
                        dealId={dealId}
                        saveSelection={saveSelection}
                        fetchCompanyMetrics={fetchCompanyMetrics}
                        dealStatus={dealStatus}
                    />
                )}

                {showDetailOverview && <DebtProductOverview data={showDetailOverview} closeModal={() => setShowDetailOverview(null)} />}
            </div>
            <div
                className={clsx(styles.Footer, {
                    [styles.FooterShift]: commentsThreadState.showCommentsThread && !commentsThreadState.closingCommentsThread,
                })}
                style={{
                    ...(draftSelectionCount > 0 || selectionCount > 0
                        ? { bottom: '0', opacity: '1', height: 'auto', visibility: 'visible' }
                        : {}),
                    ...(isCompanySide ? { left: '2.125rem' } : {}),
                }}
            >
                {user.userData.accountType !== USER_TYPE.COMPANY && (
                    <div className={styles.FooterText}>
                        {renderMessage()}
                        <div className={styles.FooterBtnContainer}>
                            <div className={styles.ProductLenderCount}>
                                <span className={styles.ProductCount}>
                                    Debt Options: <span style={{ color: '#6021B3' }}>{dealPayload.products.length}</span>
                                </span>
                                <span className={styles.LenderCount}>
                                    Lenders: <span style={{ color: '#6021B3' }}>{dealPayload.lenders.size}</span>
                                </span>
                            </div>
                            {!savingDraft && renderClearOrDeleteButton(dealId)}
                            {savingDraft ? (
                                <AIText text={'Saving and adding it on Mandate'} />
                            ) : (
                                renderDealActionButton(dealId, searchParams, setSearchParams)
                            )}
                        </div>
                    </div>
                )}
            </div>

            <AskAicaV2 selectedCompany={selectedCompany} global />
        </>
    );
}

export default DebtProducts;
